// Manages audiospatialisation

import * as audio from '../audio.js';

export {
    createPanner,
    positionListener, orientListener,
    play,
}

function createPanner (options = {}) {    
    const panner = audio.context.createPanner();
    
    panner.panningModel = 'HRTF';
    panner.distanceModel = "exponential";
    panner.refDistance = 1;
    panner.maxDistance = 20;
    panner.rolloffFactor = 2;
    // panner.coneInnerAngle = 360;
    // panner.coneOuterAngle = 0;
    // panner.coneOuterGain = 0;
    
    if (panner.orientationX) {
        panner.orientationX.setValueAtTime(0, audio.context.currentTime);
        panner.orientationY.setValueAtTime(0, audio.context.currentTime);
        panner.orientationZ.setValueAtTime(-1, audio.context.currentTime);
    } else {
        panner.setOrientation(0, 0, -1);
    }

    panner.positionPanner = function (x, y, z) {
        if (panner.positionX) {
            panner.positionX.setValueAtTime(x, audio.context.currentTime);
            panner.positionY.setValueAtTime(y, audio.context.currentTime);
            panner.positionZ.setValueAtTime(z, audio.context.currentTime);
        } else {
            panner.setPosition(x, y, z);
        }
    }

    panner.connect(options.destination || audio.context.destination);

    return panner;
}

function positionListener(x, y, z) {
    const listener = audio.context.listener;

    if (listener.positionX) {
        listener.positionX.setValueAtTime(x, audio.context.currentTime);
        listener.positionY.setValueAtTime(y, audio.context.currentTime);
        listener.positionZ.setValueAtTime(z, audio.context.currentTime);
    } else {
        listener.setPosition(x, y, z);
    }
}

function orientListener(direction) {
    // Orient the listener in the direction of the player
    // The direction is given in degrees (0 to 360) in a 2d ground plane
    // Facing the screen is 0, facing right is 90, facing left is -90
    // FIXME: There is no up/down orientation implemented yet

    const deltaAngleX = Math.abs(direction + 90) % 360;
    const deviationX = (deltaAngleX < 180) ? deltaAngleX : 360 - deltaAngleX;
    const deltaAngleZ = Math.abs(direction) % 360;
    const deviationZ = (deltaAngleZ < 180) ? deltaAngleZ : 360 - deltaAngleZ;

    const fx = (deviationX / 180) * 2 - 1;
    const fy = 0;
    const fz = (deviationZ / 180) * 2 - 1;
    const ux = 0;
    const uy = 1;
    const uz = 0;

    const listener = audio.context.listener;

    if (listener.forwardX) {
        listener.forwardX.setValueAtTime(fx, audio.context.currentTime);
        listener.forwardY.setValueAtTime(fy, audio.context.currentTime);
        listener.forwardZ.setValueAtTime(fz, audio.context.currentTime);
        listener.upX.setValueAtTime(ux, audio.context.currentTime);
        listener.upY.setValueAtTime(uy, audio.context.currentTime);
        listener.upZ.setValueAtTime(uz, audio.context.currentTime);
    } else {
        listener.setOrientation(fx, fy, fz, ux, uy, uz);
    }
}

function play (p) {
    // p for POI
    const panner = createPanner();
    panner.positionPanner(p.position.x, p.position.z, p.position.y);
    p.sound.panner = panner;
    audio.buffers.play(p.sound.name, {
        // TODO: this should probably merged with defaults in buffers.js
        gain: p.sound.gain || 0,
        loop: p.sound.loop || true,
        when: p.sound.when || 0,
        destination: panner,
        defer: p.sound.defer,
    }).then((source) => {
        p.sound.source = source;
    });
}